import { render, staticRenderFns } from "./AutoCollections.vue?vue&type=template&id=3f552631&scoped=true&"
import script from "./AutoCollections.vue?vue&type=script&lang=js&"
export * from "./AutoCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f552631",
  null
  
)

export default component.exports